import { CommonCivilStatusCrumbs } from './breadcrumb';

export const DocumentSerieListCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Lista Serie',
    path: '/stato-civile/serie',
  },
];

export const DocumentSerieNewCrumbs = [
  ...DocumentSerieListCrumbs,
  {
    name: 'Nuova Serie',
    path: '/stato-civile/serie/nuovo',
  },
];

export const DocumentSerieEditCrumbs = [
  ...DocumentSerieListCrumbs,
  {
    name: 'Modifica Serie',
    path: '/stato-civile/serie/modifica',
  },
];

export const DocumentSerieVisualizeCrumbs = [
  ...DocumentSerieListCrumbs,
  {
    name: 'Visualizza Serie',
    path: '/stato-civile/serie/visualizza',
  },
];
